import material from './colors/material';
import em from '../utils/em';

const baseFontSize = 16;
const brandColor = '#25D366';
const serif = 'Consolas, Menlo, Monaco, "Lucida Console", "Liberation Mono", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Courier New", monospace, serif';
const sanSerif = '"Proxima Nova", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial, sans-serif';

const theme = {
  // Base font size: 16px
  breakpoints: [
    // smartphones
    960 / baseFontSize, // 960px
    // tablets
    1280 / baseFontSize, // 1280px
    // laptops
    1440 / baseFontSize, // 1440px
    // desktops - 2 tiles
    1600 / baseFontSize, // 1600px
    // large screens - 3 tiles
    1920 / baseFontSize, // 1920px
    // very large screens - 4 tiles
  ],
  space: [
    0,
    4,
    8,
    16,
    32,
    64,
    100,
    128,
  ],
  fontSizes: [
    12.8,
    14,
    16,
    20,
    24,
    32,
    48,
    64,
    72,
    96,
  ],
  weights: [
    400,
    700,
  ],
  colors: {
    brand: brandColor,
    brandDark: '#0a4420',
    brandLight: '#5cb85c',
    white: '#fff',
    greyExtraLight: material.grey['100'],
    greyLight: material.grey['200'],
    grey: material.grey['600'],
    black: '#120121',
    orange: '#F58A33',
  },
  radius: 4,
  font: serif,
  monospace: serif,
  sansSerif: sanSerif,
};

const mobileMaxWidth = theme.breakpoints[1];
const mobileMaxWidthEm = em(mobileMaxWidth);

export default {
  ...theme,

  // Custom stuff
  mobileMaxWidth,
  mobileMaxWidthEm,
};



// WEBPACK FOOTER //
// ./src/app/themes/default.js